import { defineComponent } from 'vue';
import HomeBanner from './components/HomeBanner.vue';
import FeatureArea from './components/FeatureArea.vue';
import HomeQceit from './components/HomeQceit.vue';
import SwiperActivityArea from './components/SwiperActivityArea.vue';
import ExcellentWorkArea from './components/ExcellentWorkArea.vue';
import HomeContestInfomation from './components/HomeContestInfomation.vue';
import HomePartner from './components/HomePartner.vue';
import { declareProviders } from '@kaokei/use-vue-service';
import { HomeService } from '@/services/home.service';
export default defineComponent({
  name: 'Home',
  components: {
    HomeBanner: HomeBanner,
    FeatureArea: FeatureArea,
    SwiperActivityArea: SwiperActivityArea,
    HomeQceit: HomeQceit,
    ExcellentWorkArea: ExcellentWorkArea,
    HomeContestInfomation: HomeContestInfomation,
    HomePartner: HomePartner
  },
  setup: function setup() {
    declareProviders([HomeService]);
  }
});